import React, { useState, useEffect } from "react";
import classes from "./styles/style.module.css";
import CustomButton from "../../../../assets/components/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import appApi from "../../../../assets/utils/AppApi";
import errorHandler from "../../../../assets/utils/ErrorHandler";
import {
  setLastQuestionId,
  setQuestionAnswered,
  setRightAnswer,
} from "../../../../assets/redux/actions/Quiz";

export default function SubmitButtonContainer() {
  const { questionAnswer, rightAnswer } = useSelector(({ quiz }) => quiz);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (rightAnswer === "پازل صحیح است") {
      answerQuestion();
    }
  }, [questionAnswer]);

  const answerQuestion = () => {
    dispatch(setLastQuestionId(""));
    setLoading(true);
    const ticketId = localStorage.getItem("Ticket");
    questionAnswer["ticketId"] = ticketId;
    appApi
      .post(`/quizanswer/create`, questionAnswer)
      .then(({ data }) => {
        dispatch(setQuestionAnswered(data.quizAnswer));
        setLoading(false);
        dispatch(setRightAnswer(null));
        // window.history.back();
      })
      .catch((error) => {
        errorHandler(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClick = () => {
    if (!questionAnswer) {
      toast.error("یک جواب را انتخاب نمایید");
    } else {
      if (loading) {
        toast.error("لطفا کمی صبر نمایید !!");
      } else {
        answerQuestion();
      }
    }
  };
  return (
    <div className={classes.submitButtonContainer}>
      <CustomButton
        text={"ثبت"}
        clickHandler={handleClick}
        styles={{
          backgroundColor: "#543ACC",
          padding: "18px 16px",
          fontSize: "20px",
        }}
      />
    </div>
  );
}
